import Browser from '@wetransfer/concorde-browser';

export const init = () => {
  const { classList } = document.documentElement;

  if (Browser.supportsTouchEvents) {
    classList.remove('no-touch');
    classList.add('has-touch');
  }

  if (Browser.isMobile) {
    classList.add('is-mobile-ready');
  }
};
